<script setup lang="ts">
import { computed } from 'vue';
import { useError } from '#app/composables/error';
import { hasErrorCode } from '#layers/base/utils/error';
import { useProjectStore } from '~/stores/project';

const error = useError();

const { currentProjectSlug } = useProjectStore();

const isProjectAccessDenied = computed(() => error.value && hasErrorCode(error.value, 'PROJECT_ACCESS_DENIED'));
</script>

<template>
	<div v-if="error" class="h-screen">
		<ErrorScreen :error>
			<DButton v-if="isProjectAccessDenied" to="/organization">
				{{ $t('project.back_to_projects') }}
			</DButton>
			<DButton v-else-if="!currentProjectSlug" to="/">
				Return to Dashboard
			</DButton>
			<DButton v-else :to="{ name: 'project-home', params: { project: currentProjectSlug } }">
				Return to Project
			</DButton>
		</ErrorScreen>
	</div>
</template>
